/**
 * @module ol/interaction/SWSnap
 */

import PointerInteraction from './Pointer.js';
import * as functions from '../functions.js';

var SWSnap = /*@__PURE__*/(function (PointerInteraction) {
  function SWSnap() {
    var this$1 = this;

    PointerInteraction.call(this, {
      handleEvent: function (evt) { return this$1.handleEvent_(evt); },
      handleDownEvent: functions.TRUE,
      handleUpEvent: function (evt) { return this$1.handleUpEvent_(evt); },
      stopDown: functions.FALSE
    });

    this._snapEvent = null;
  }

  if ( PointerInteraction ) SWSnap.__proto__ = PointerInteraction;
  SWSnap.prototype = Object.create( PointerInteraction && PointerInteraction.prototype );
  SWSnap.prototype.constructor = SWSnap;

  /**
   * Change snap event
   * @api stable
   * @export
   */
  SWSnap.prototype.setEvent = function setEvent (evt) {
    this._snapEvent = evt;
  };

  /**
   * Handle all pointer events.
   * @param evt A move event.
   * @return {boolean} Pass the event to other interactions.
   * @this {ol.interaction.SWSnap}
   * @private
   */
  SWSnap.prototype.handleEvent_ = function handleEvent_ (/** @type {import("../MapBrowserEvent.js").default} */ evt) {
    if (this._snapEvent !== null) {
      var result = this._snapEvent;
      if (result['snapped']) {
        evt.coordinate = result['vertex'].slice(0, 2);
        evt.pixel = result['vertexPixel'];
      }
    }    
    return PointerInteraction.prototype.handleEvent.call(this, evt);
  };

  /**
   * @param evt Event.
   * @return {boolean} Stop drag sequence?
   * @this {ol.interaction.SWSnap}
   * @private
   */
  SWSnap.prototype.handleUpEvent_ = function handleUpEvent_ (/** @type {import("../MapBrowserPointerEvent.js").default} */ evt) {
    return false;
  };

  return SWSnap;
}(PointerInteraction));

export default SWSnap;

//# sourceMappingURL=SWSnap.js.map